module.exports = __webpack_public_path__ + "static/img/IMG_20150610_223745.c52571cf.jpg";